import { inject } from "vue";

export function use<T> (symbol: symbol): T {
    const service = inject(symbol);
    if (!service) {
        throw new Error(`${symbol.toString()} not provided`);
    }
    return service as T;
}
